import type { Currency } from '@backmarket/http-api'
import { getCustomerId } from '@backmarket/http-api/src/api-specs-crm-service/crm-service/customer'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

export async function updateUserContext() {
  const { user } = useUserStore()

  if (!user.value.userId) {
    return
  }

  try {
    const crmData = user.value.clientId
      ? await $httpFetch(getCustomerId)
      : undefined
    const crmId = crmData ? crmData.crmId : ''

    const tracking = useTracking()

    tracking.setUserContext({
      userId: user.value.userId,
      isStaff: user.value.isStaff,
      clientId: user.value.clientId,
      emailHashed: user.value.emailHashed || '',
      merchantId: user.value.merchantId,
      lastOrderDate: String(user.value.lastOrderDate),
      numberOfOrders: user.value.numberOfOrders,
      lifetimeRevenue: {
        currency: <Currency>user.value.lifetimeRevenue.currency || '',
        amount: String(user.value.lifetimeRevenue.amount),
      },
      crmId,
    })
  } catch (err) {
    const logger = useLogger()

    const error = err as Error
    logger.error(error.message, {
      error,
      owners: ['bot-chapter-frontend-core-pastrami'],
    })
  }
}
